"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_DATETIME_FORMATS = exports.CBH_LONG_DATE_TIME_WITH_TIME_ZONE_FORMAT = exports.CBH_DATE_TIME_WITH_TIME_ZONE_FORMAT = exports.CBH_TIME_ZONE_FORMAT = exports.CBH_DATE_TIME_FORMAT = exports.CBH_TIME_FORMAT = exports.CBH_LONG_DATE_FORMAT = exports.CBH_DATE_FORMAT = void 0;
exports.CBH_DATE_FORMAT = `PP`; // E.g. Apr 20, 2023
exports.CBH_LONG_DATE_FORMAT = "PPPP"; // E.g. Thursday, April 20th, 2023
exports.CBH_TIME_FORMAT = "p"; // E.g. 4:20 PM
exports.CBH_DATE_TIME_FORMAT = `${exports.CBH_DATE_FORMAT}, ${exports.CBH_TIME_FORMAT}`; // E.g. Apr 20, 2023, 4:20 PM
exports.CBH_TIME_ZONE_FORMAT = "zzz"; // E.g. Thursday, April 20th, 2023 at 4:20 PM EDT
exports.CBH_DATE_TIME_WITH_TIME_ZONE_FORMAT = `${exports.CBH_DATE_FORMAT}, ${exports.CBH_TIME_FORMAT} ${exports.CBH_TIME_ZONE_FORMAT}`; // E.g. Apr 20, 2023, 4:20 PM EDT
exports.CBH_LONG_DATE_TIME_WITH_TIME_ZONE_FORMAT = `PPPPp ${exports.CBH_TIME_ZONE_FORMAT}`; // E.g. Thursday, April 20th, 2023 at 4:20 PM EDT
exports.VALID_DATETIME_FORMATS = [
    exports.CBH_DATE_FORMAT,
    exports.CBH_LONG_DATE_FORMAT,
    exports.CBH_TIME_FORMAT,
    exports.CBH_DATE_TIME_FORMAT,
    exports.CBH_TIME_ZONE_FORMAT,
    exports.CBH_DATE_TIME_WITH_TIME_ZONE_FORMAT,
    exports.CBH_LONG_DATE_TIME_WITH_TIME_ZONE_FORMAT,
];
//# sourceMappingURL=constants.js.map